import React from 'react';
import moment from 'moment';
import { strings } from '../../../resources/strings';
import { IFilterToListCustomersOutput } from '../ModalFiltersToListCustomers/ModalFiltersToListCustomers';
import { Container, Filter, FilterName, FilterValue, Title, FiltersDesktop, FiltersMobile, FiltersWhatever, Filters } from './styles';

interface IFiltersProps {
    appliedFilters?: IFilterToListCustomersOutput;
    marginTop?: string;
}

const AppliedFiltersToListCustomers: React.FC<IFiltersProps> = ({
    appliedFilters,
    marginTop
}) => {

    const anyAppliedFilter = 
            appliedFilters?.document ||
            appliedFilters?.name ||
            appliedFilters?.email ||
            appliedFilters?.phone ||
            appliedFilters?.creationStartDate ||
            appliedFilters?.creationEndDate ||
            appliedFilters?.lastModificationStartDate ||
            appliedFilters?.lastModificationEndDate;

    const renderFilter = (name: string, value?: string|null) => {
        if (!value) return null;

        return (
            <Filter>
                <FilterName>{name}: </FilterName>
                <FilterValue>{value}</FilterValue>
            </Filter>
        );
    }

    const renderFilterDates = (name: string, startValue?: Date|null, endValue?: Date|null) => {
        if (!startValue && !endValue) return null;

        let value = '';
        value += startValue ? 'de ' + moment(startValue).format('DD/MM/yyyy') : '';
        value += endValue ? ' até ' + moment(endValue).format('DD/MM/yyyy') : '';

        return (
            <Filter>
                <FilterName>{name}: </FilterName>
                <FilterValue>{value}</FilterValue>
            </Filter>
        );
    }

    if (!anyAppliedFilter) {
        return (
            <Container marginTop={marginTop}>
                <Title>{strings.AppliedFilters}</Title>
                <FiltersDesktop>{strings.None}</FiltersDesktop>
                <FiltersMobile>{strings.NoFilterApplied}</FiltersMobile>
            </Container>
        );
    }

    return (
        <Container marginTop={marginTop}>
            <Title>{strings.AppliedFilters}</Title>
            <Filters>
                <FiltersWhatever>
                    { renderFilter('CPF/CNPJ', appliedFilters?.document) }
                    { renderFilter(strings.Name, appliedFilters?.name) }
                    { renderFilter(strings.Email, appliedFilters?.email) }
                    { renderFilter(strings.Phone, appliedFilters?.phone) }
                    { renderFilterDates(strings.Registered, appliedFilters?.creationStartDate, appliedFilters?.creationEndDate) }
                    { renderFilterDates(strings.Change, appliedFilters?.lastModificationStartDate, appliedFilters?.lastModificationEndDate) }
                </FiltersWhatever>
            </Filters>
        </Container>
    );
}

export {AppliedFiltersToListCustomers};